export default __webpack_public_path__ + "static/media/element_103.7fd3dc67.jpg";